import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { makeStyles } from '@fluentui/react-components';
import { COLORS } from '../tokens';

const useStyles = makeStyles({
  container: {
    padding: '24px 32px',
    maxWidth: '860px',
  },
  markdown: {
    lineHeight: '1.7',
    color: COLORS.textPrimary,
    '& h1': {
      fontSize: '28px',
      fontWeight: '700',
      marginTop: '0',
      marginBottom: '16px',
      color: COLORS.textPrimary,
    },
    '& h2': {
      fontSize: '21px',
      fontWeight: '600',
      marginTop: '32px',
      marginBottom: '12px',
      paddingBottom: '6px',
      borderBottom: `1px solid ${COLORS.borderSubtle}`,
      color: COLORS.textPrimary,
    },
    '& h3': {
      fontSize: '16px',
      fontWeight: '600',
      marginTop: '24px',
      marginBottom: '8px',
      color: COLORS.textSecondary,
    },
    '& p': {
      marginTop: '0',
      marginBottom: '12px',
      fontSize: '14px',
    },
    '& ul, & ol': {
      paddingLeft: '24px',
      marginBottom: '12px',
      fontSize: '14px',
    },
    '& li': {
      marginBottom: '4px',
    },
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      marginBottom: '16px',
      fontSize: '13px',
    },
    '& th': {
      textAlign: 'left',
      padding: '8px 12px',
      backgroundColor: COLORS.bgSurface,
      borderBottom: `2px solid ${COLORS.borderSubtle}`,
      fontWeight: '600',
      color: COLORS.textSecondary,
    },
    '& td': {
      padding: '8px 12px',
      borderBottom: `1px solid ${COLORS.borderSubtle}`,
    },
    '& code': {
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: '12px',
      backgroundColor: COLORS.bgSurface,
      padding: '2px 6px',
      borderRadius: '3px',
    },
    '& blockquote': {
      marginLeft: '0',
      paddingLeft: '16px',
      borderLeft: `3px solid ${COLORS.primary}`,
      color: COLORS.textSecondary,
      fontStyle: 'italic',
    },
    '& hr': {
      border: 'none',
      borderTop: `1px solid ${COLORS.borderSubtle}`,
      marginTop: '24px',
      marginBottom: '24px',
    },
    '& strong': {
      fontWeight: '600',
    },
  },
});

interface MarkdownPageProps {
  content: string;
}

export function MarkdownPage({ content }: MarkdownPageProps) {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <div className={styles.markdown}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      </div>
    </div>
  );
}

export type { MarkdownPageProps };
